import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod, putMethod2 } from "../../services/ApiCallMethods";

// GET: Fetch user profile
export const getUserProfile = createAsyncThunk(
  "profile/getUserProfile",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await getMethod(`/api/user/${userId}`);
        if (response.status === 403) {
        return rejectWithValue("Your account is suspended now");
      }
      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data?.error || data?.message);
      }

      return data;
    } catch (error) {
      return rejectWithValue("Network error");
    }
  }
);



// PUT: Update user profile
export const updateUserProfile = createAsyncThunk(
  "profile/updateUserProfile",
  async ({ userId, profileData }, { rejectWithValue }) => {
    try {
      const response = await putMethod2(`/api/user/${userId}`, profileData);
      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data?.error || data?.message || "Failed to update user profile");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to update profile");
    }
  }
);

// Initial State
const initialState = {
  profile: null,
  loading: false,
  error: null,
  success: false,
  updateSuccess: false,
};

// Slice
const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfileState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Profile
      .addCase(getUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.user;
        state.success = true;
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload||"Failed to fetch";
        state.success = false;
      })

      // Update Profile
      .addCase(updateUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
        state.updateSuccess = true;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.updateSuccess = false;
      });
  },
});

export const { clearProfileState } = profileSlice.actions;

export default profileSlice.reducer;
